<template>
  <div
    class="flex"
    :class="props.titleTop ? 'flex-col' : 'flex-row  items-center'"
  >
    <template v-if="state.slots?.title">
      <slot name="title"></slot>
    </template>
    <text
      v-else
      class="text-gray-400 whitespace-nowrap"
      :class="titleClass"
      :style="`font-size:${props.size}px;${titleStyle}`"
    >
      {{ props.title + "：" }}
    </text>
    <template v-if="state.slots?.default">
      <div
        :style="{
          fontSize: props.size + 'px',
        }"
      >
        <slot
          name="default"
          :style="{
            fontSize: props.size + 'px',
          }"
        ></slot>
      </div>
    </template>
    <text
      v-else
      :class="valueClass"
      :style="`font-size:${props.size}px;${valueStyle}`"
    >
      {{
        props.showEmpty
          ? props.value
          : judgeNullExceptZero(props.value)
          ? "-"
          : props.value
      }}
    </text>
  </div>
</template>

<script>
import { onMounted, reactive, useSlots } from "vue";
import { judgeNullExceptZero } from "@/utils/format";

export default {
  props: {
    size: {
      type: Number,
      default: () => 13,
    },
    title: String,
    value: String,
    titleClass: Object,
    valueClass: Object,
    titleStyle: String,
    valueStyle: Object,
    showEmpty: {
      //如果值为空时显示空白，默认显示 -
      type: Boolean,
      default: () => false,
    },
    titleTop: {
      //为true时标题在内容上方    默认在同一行
      type: Boolean,
      default: () => false,
    },
  },
  setup(props) {
    const state = reactive({});
    onMounted(() => {
      state.slots = useSlots();
    });
    return { state, props, judgeNullExceptZero };
  },
};
</script>

<style lang="scss" scoped></style>
